const sendToBus = (name, payload) => {
  try {
    window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
  } catch (err) {
    console.error('[loyalty-benefits] Analytics event failed:', name, err);
  }
};

const pushToDigitalData = (payload) => {
  try {
    const targetWindow = (window.top && window.top !== window) ? window.top : window;
    if (targetWindow.digitalData) {
      targetWindow.digitalData.event = targetWindow.digitalData.event || [];
      targetWindow.digitalData.event.push(payload);
      if (typeof targetWindow.digitalData.init === 'function') {
        targetWindow._T = targetWindow._T || {};
        targetWindow._T.pageData = targetWindow._T.pageData || [];
        targetWindow._T.pageData.push(targetWindow.digitalData.init());
      }
    }
  } catch (err) {
    console.error('[loyalty-benefits] Analytics event failed:', err);
  }
};

const analyticsPrefixes = {
  welcomeCard: 'homepage: welcome: nav',
  pacDrawer: 'rewards hub',
  sweepstakes: 'sweepstakes',
};

export const analyticsClick = (prefix, message) => {
  sendToBus('loyalty-benefits.loyalty-button', {
    settings: `${analyticsPrefixes[prefix]}: ${message}`
  });
};

export const analyticsOverlay = (prefix, message) => {
  sendToBus('loyalty-benefits.loyalty-overlay', {
    settings: `${analyticsPrefixes[prefix]}: ${message}`
  });
};

export const analyticsStash = (prefix, message, link = '') => {
  const addLink = link ? `: ${link}` : '';
  sendToBus('loyalty-benefits.loyalty-stash', {
    settings: `${analyticsPrefixes[prefix]}: ${message}` + addLink,
  });
};

export const analyticsVideo = (primaryCategory, videoData = {}) => {
  const payload = { category: { primaryCategory } };
  if (Object.keys(videoData).length) {
    const video = {};
    if (videoData.name !== undefined) video.name = videoData.name;
    if (videoData.id !== undefined) video.id = videoData.id;
    if (videoData.type !== undefined) video.type = videoData.type;
    payload.video = video;
  }
  sendToBus('loyalty-benefits.loyalty-video', payload);
};

export const analyticsSweepstakesTrackYourEntriesButton = (component, campaign) => {
  pushToDigitalData({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'content module click' },
    content: {
      widgets: [{
        action: 'click',
        id: 'fifa sweepstakes',
        name: 'track your entries overlay',
        templates: 'task',
        campaign,
        component,
        element: 'n/a',
      }],
    },
  });
};

export const analyticsSweepstakesDrawerOpen = (component, name, campaign) => {
  pushToDigitalData({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'content module click' },
    content: {
      widgets: [{
        action: 'open',
        id: 'fifa sweepstakes',
        name,
        templates: 'task',
        campaign,
        component,
        element: 'n/a',
      }],
    },
  });
};

export const analyticsSweepstakesDrawerOpenButton = (component, name, campaign) => {
  pushToDigitalData({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'content module click' },
    content: {
      widgets: [{
        action: 'open',
        id: 'fifa sweepstakes',
        name,
        templates: 'task',
        campaign,
        component,
        element: 'n/a',
      }],
    },
  });
};

export const analyticsSweepstakesOverlayExit = (component, name, campaign) => {
  pushToDigitalData({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'content module click' },
    content: {
      widgets: [{
        action: 'exit',
        id: 'fifa sweepstakes',
        name,
        templates: 'task',
        campaign,
        component,
        element: 'n/a',
      }],
    },
  });
};

export const analyticsSweepstakesWelcomeCard = (component) => {
  pushToDigitalData({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'content module click' },
    content: {
      widgets: [{
        action: 'click',
        id: 'fifa sweepstakes',
        name: 'welcome card',
        templates: 'n/a',
        campaign: 'n/a',
        component,
        element: 'n/a',
      }],
    },
  });
};

export const analyticsSweepstakesPostPageError = ({
  type,
  displayType,
  pageSection,
  message,
  code
}) => {
  const payload = {
    category: { primaryCategory: 'error' },
    eventInfo: {
      eventName: 'post page error',
      error: [{
        type,
        displayType,
        pageSection,
        message,
        code
      }],

    },
  };
  pushToDigitalData(payload);
};
